import pdfMake from 'pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import useDate from '@/services/utils/day';
import figureFormatter from '@/services/utils/figureFormatter';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const sulaimanLipiFont = {
    SulaimanLipi: {
        normal: 'https://fonts.cdnfonts.com/s/14639/solaimanlipi.woff',
        bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
        italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
        bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
    }
}
pdfMake.fonts = sulaimanLipiFont;

const orderProductionDashboardPdf = () => {
    const { formatDate } = useDate();
    const { commaFormat, onlyCommaFormat } = figureFormatter();

    const exportToPDF = (company, rows, filters, userName) => {
        pdfMake.fonts = sulaimanLipiFont;

        const docDefinition = {
            pageSize: 'A4',
            pageOrientation: 'portrait',
            pageMargins: [20, 100, 20, 80],
            header: getHeader(company),
            footer: getFooter(userName),
            content: getContent(rows, filters),
            defaultStyle: {
                fontSize: 7,
                color: '#333',
                font: 'SulaimanLipi'
            },
            info: {
                title: 'Order Production'
            }
        };

        pdfMake.createPdf(docDefinition).open();
    };

    const getContent = (rows, filters) => {
        return [
            { text: 'Order Production', fontSize: 14, bold: true, alignment: 'center', margin: [0, 0, 0, 6] },
            getFilterSummary(filters),
            getRowsTable(rows)
        ];
    };

    const getFilterSummary = (filters) => {
        const groupByLabel = filters.groupBy === 'item' ? 'Item' : 'Category';
        return {
            text: `Product Type: ${filters.productTypeLabel}    Grouped By: ${groupByLabel}    Period: ${filters.start} to ${filters.end}`,
            fontSize: 9,
            alignment: 'center',
            margin: [0, 0, 0, 12]
        };
    };

    const getRowsTable = (rows) => {
        return {
            table: {
                headerRows: 1,
                widths: ['16%', '10.5%', '10.5%', '10.5%', '10.5%', '10.5%', '10.5%', '10.5%', '10.5%'],
                body: [getTableHeaderRow(), ...rows.map(getTableDataRow)]
            },
            layout: {
                hLineWidth: () => 0.5,
                vLineWidth: () => 0.5,
                fillColor: (rowIndex) => (rowIndex === 0) ? '#f3f2f7' : null
            }
        };
    };

    const getTableHeaderRow = () => {
        return [
            { text: 'Name', bold: true },
            { text: 'Order Qty', bold: true, alignment: 'right' },
            { text: 'Order Value', bold: true, alignment: 'right' },
            { text: 'Production Qty', bold: true, alignment: 'right' },
            { text: 'Production Value', bold: true, alignment: 'right' },
            { text: 'Delivery Qty', bold: true, alignment: 'right' },
            { text: 'Delivery Value', bold: true, alignment: 'right' },
            { text: 'Stock In Hand Qty', bold: true, alignment: 'right' },
            { text: 'Stock In Hand Value', bold: true, alignment: 'right' }
        ];
    };

    const getTableDataRow = (row) => {
        return [
            { text: row.name || '' },
            { text: onlyCommaFormat(row.order_qty), alignment: 'right' },
            { text: commaFormat(row.order_value), alignment: 'right' },
            { text: onlyCommaFormat(row.production_qty), alignment: 'right' },
            { text: commaFormat(row.production_value), alignment: 'right' },
            { text: onlyCommaFormat(row.delivery_qty), alignment: 'right' },
            { text: commaFormat(row.delivery_value), alignment: 'right' },
            { text: onlyCommaFormat(row.stock_in_hand_qty), alignment: 'right' },
            { text: commaFormat(row.stock_in_hand_value), alignment: 'right' }
        ];
    };

    const getHeader = (company) => {
        return {
            margin: [30, 25, 30, 10],
            columns: [
                {
                    alignment: 'left',
                    image: company.logo64,
                    maxHeight: 60
                },
                {
                    alignment: 'right',
                    stack: [
                        company.name,
                        'Address: ' + company.address,
                        'Phone: ' + company.phone,
                        'E-mail: ' + company.email
                    ]
                }
            ]
        };
    };

    const getFooter = (userName) => {
        return {
            margin: [25, 0],
            columns: [
                {
                    width: '80%',
                    alignment: 'left',
                    text: 'N.B: This is a system generated documents and requires no manual signature.',
                    margin: [5, 53, 0, 0],
                    fontSize: 8
                },
                {
                    width: '20%',
                    alignment: 'right',
                    fontSize: 8,
                    margin: [0, 33, 0, 0],
                    stack: [
                        { text: 'Printed by', bold: true },
                        { text: userName },
                        { text: formatDate(new Date()) }
                    ]
                }
            ]
        };
    };

    return {
        exportToPDF
    };
};

export default orderProductionDashboardPdf;
